<div class="container">
  <div class="container__image">
    <img src="/assets/images/promise.png" alt="#">
  </div>
  <div class="container__content">
    <div class="content">
      <div class="content__title">
        <app-image-title
          type="promise"
        >大切にしていること</app-image-title>
      </div>
      <div class="content__text">
        <p class="text">子供の未来は地球の未来だと、わたしたちBÜKI（ブーキー）は考えています。</p>
      </div>
      <div class="content__text">
        <p class="text">オーダーメイドなので、読まれない絵本は作りません。絵本には、森を守る活動の基準に沿って生産された紙を使用しています。子供たちに喜んでもらえる絵本作りに加えて、まだまだできることは小さいですが一歩ずつ、これからの子供が生きる地球のために今できる取り組みをしていきます。</p>
      </div>
    </div>
  </div>
</div>
